import React, { ComponentProps } from 'react';
import KitDynamicTrackPage from '@narvar/nth-kit-dynamic-track-page';
import { Devices } from '../lib/types';

const PageComponent: React.FunctionComponent<{
  userAgentDevice: Devices;
  renderHeader: boolean;
  apollo: ComponentProps<typeof KitDynamicTrackPage>['apollo'];
  analytics: ComponentProps<typeof KitDynamicTrackPage>['analytics'];
  growthbook: ComponentProps<typeof KitDynamicTrackPage>['growthbook'];
  titanAnalyticsOptions: ComponentProps<
    typeof KitDynamicTrackPage
  >['titanAnalyticsOptions'];
  initialState: ComponentProps<typeof KitDynamicTrackPage>['initialState'];
  onUnauthenticatedRequest: ComponentProps<
    typeof KitDynamicTrackPage
  >['onUnauthenticatedRequest'];
}> = ({
  apollo,
  analytics,
  growthbook,
  titanAnalyticsOptions,
  initialState,
  userAgentDevice,
  renderHeader,
  onUnauthenticatedRequest,
}) => (
  <main role="main">
    <KitDynamicTrackPage
      userAgentDevice={userAgentDevice}
      renderHeader={renderHeader}
      apollo={apollo}
      analytics={analytics}
      growthbook={growthbook}
      titanAnalyticsOptions={titanAnalyticsOptions}
      initialState={initialState}
      onUnauthenticatedRequest={onUnauthenticatedRequest}
    />
  </main>
);

export default PageComponent;
